export default () => {
  $('[data-product-tiles] .grid').html('<div class="products__no-results column-xs-12">Sorry, no products matched your selection</div>');
  $('[data-collection-grid-container] [data-show-mobile-filter-nav]').removeClass('active');
  $('[data-load-more]').addClass('hide');
  $('[data-total-filtered-items]').text('0 items');
  // $('html, body').animate({ scrollTop: $('[data-products]').offset().top - $('.shopify-section.header').outerHeight() + 20 }, 'slow');
};
